import { helper } from '@ember/component/helper';
import { MultipleBankAccountsStep } from '@square/dashboard-protos/models/squareup/bbfrontend/common/bank_account/plaid_linking_models';
function getBannerStyles([bannerStyle]) {
  switch (bannerStyle) {
    case MultipleBankAccountsStep.AlertBanner.IconStyle.WARNING:
      return 'warning';
    case MultipleBankAccountsStep.AlertBanner.IconStyle.CRITICAL:
      return 'critical';
    case MultipleBankAccountsStep.AlertBanner.IconStyle.EMPHASIS:
    default:
      return 'emphasis';
  }
}
export default helper(getBannerStyles);